import{createElement as e}from"../../../external/preact/dist/preact.js";const a=({children:a,className:t})=>e("div",{className:`adyen-checkout-timeline-wrapper ${t}`},a);export{a as TimelineWrapper};
//# sourceMappingURL=TimelineWrapper.js.map
